import clientApi from './clientApi';

const clientService = {
  listCertificates: async () => {
    const response = await clientApi.get('/api/client/certificates');
    return response.data;
  },

  downloadCertificate: async (submissionId) => {
    const response = await clientApi.get(
      `/api/client/certificates/${submissionId}/download`,
      { responseType: 'blob' }
    );
    return response;
  },
};

export default clientService;
